import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appMuAccordionPreviewTemplate]',
})
export class MuAccordionPreviewTemplateDirective {
  @Input('appMuAccordionPreviewTemplate') name: string;

  constructor(public template: TemplateRef<any>) {
    /** */
  }
}
